module.exports = __webpack_public_path__ + "static/img/seed.cffd9d5b.png";